'use client';

import Script from 'next/script';

export function AfterPayScript() {
    return <Script data-testid="square-script" src={process.env.NEXT_PUBLIC_AFTERPAY_SCRIPT_URL} async />;
}
